import { motion } from 'framer-motion';
import { FaGraduationCap, FaCross, FaUsers } from 'react-icons/fa';
import Breadcrumb from '../components/Breadcrumb';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb crumbs={[
        { name: 'Home', href: '/' },
        { name: 'About Good Shepherd School', href: '/about' },
      ]} />
      {/* Hero Section */}
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="relative h-[400px] bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=1920')"
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative h-full max-w-7xl mx-auto px-4 flex items-center">
          <div className="text-white">
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-4xl font-bold mb-4"
            >
              About Good Shepherd School
            </motion.h1>
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="text-xl max-w-2xl"
            >
              Developing character strength and academic excellence since 2002
            </motion.p>
          </div>
        </div>
      </motion.section>

      {/* Mission & Vision */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="bg-white p-6 rounded-lg shadow-lg"
            >
              <h2 className="text-2xl font-bold mb-4">Our Vision</h2>
              <p className="text-gray-600">
                To maintain a high academic standard ensuring that pupils obtain quality education
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="bg-white p-6 rounded-lg shadow-lg"
            >
              <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
              <p className="text-gray-600">
                To guide pupils to acquire skills, understanding and positive attitude for self reliance and Good citizenship in the fear of the Lord.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-3xl font-bold text-center mb-12"
          >
            Our Core Values
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-center"
            >
              <FaGraduationCap className="text-5xl text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Excellence</h3>
              <p className="text-gray-600">
                Maintaining continuous improvement and high academic standards
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-center"
            >
              <FaCross className="text-5xl text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Faith</h3>
              <p className="text-gray-600">
                Nurturing spiritual growth and Christian values
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="text-center"
            >
              <FaUsers className="text-5xl text-primary mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Community</h3>
              <p className="text-gray-600">
                Building strong relationships and serving others
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* History */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="bg-white p-8 rounded-lg shadow-lg"
          >
            <h2 className="text-3xl font-bold mb-6">Our History</h2>
            <p className="text-gray-600 mb-4">
              Since its founding in 2002, Good Shepherd has continued to grow with curricular and 
              Co-curricular programs that help to elevate our learners to their highest level of achievement.
            </p>
            <p className="text-gray-600 mb-4">
              For more than 20 years, we have offered an education that broadens perspectives, 
              sharpens minds, strengthens bodies, and engages hearts.
            </p>
            <p className="text-gray-600">
              Good Shepherd has a long proud tradition of scholarly, artistic, and sports excellence 
              and is considered one of Lubaga division's top private schools.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;